/**
 * Suteraa PDP AOV stacking — Complete the look (FBT) + post-ATC Complete your order.
 * Fashion-branded complete-the-look + post-ATC upsells; GMC-safe live prices.
 */
(function () {
  'use strict';

  var ADDON_MAX_CENTS = 4900;
  var BUNDLE_TIERS = [
    { min: 2, pct: 10 },
    { min: 3, pct: 15 },
    { min: 4, pct: 25 }
  ];

  function money(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function getSizedImage(src, size) {
    if (!src) return '';
    var s = String(src);
    if (s.indexOf('//') === 0) s = window.location.protocol + s;
    if (size && /(\.[a-z]+)(\?|$)/i.test(s)) {
      return s.replace(/(\.[a-z]+)(\?|$)/i, '_' + size + '$1$2');
    }
    return s;
  }

  function parseMoneyToCents(value) {
    if (value == null || value === '') return null;
    if (typeof value === 'string') return Math.round(parseFloat(value) * 100);
    var n = Number(value);
    if (isNaN(n)) return null;
    if (n > 0 && n < 1000) return Math.round(n * 100);
    return Math.round(n);
  }

  function textBlob(p) {
    var tags = p && p.tags;
    var tagStr = Array.isArray(tags) ? tags.join(' ') : String(tags || '');
    return ((p.product_type || p.type || '') + ' ' + (p.title || '') + ' ' + (p.handle || '') + ' ' + tagStr).toLowerCase();
  }

  function isJacket(p) {
    return /\b(?:jackets?|coats?|blazers?|parkas?|puffers?|trench(?:es)?|windbreakers?)\b/.test(textBlob(p));
  }

  function productKind(p) {
    if (isDress(p)) return 'dress';
    if (isJacket(p)) return 'jacket';
    if (isShoe(p)) return 'shoes';
    if (/\bskirts?\b/.test(textBlob(p))) return 'skirt';
    if (/\b(?:pants?|trousers?|jeans?|leggings?)\b/.test(textBlob(p))) return 'pant';
    if (/\b(?:tops?|blouses?|shirts?|tees?|knits?|sweaters?|cardigans?)\b/.test(textBlob(p))) return 'top';
    if (isClothes(p)) return 'clothes';
    return 'other';
  }

  var KIND_STOP = /^(women|womens|woman|the|and|with|from|this|that|for|elegant|flattering|lightweight|stylish|classic|summer|winter|outfit)$/;

  function titleTokens(p) {
    return String((p && p.title) || '').toLowerCase().replace(/[^a-z0-9\s]/g, ' ').split(/\s+/).filter(function (w) {
      return w.length > 3 && !KIND_STOP.test(w);
    });
  }

  function similarScore(seed, p) {
    if (!seed || !p) return 0;
    var sk = productKind(seed);
    var pk = productKind(p);
    var score = 0;
    if (sk && pk && sk === pk) score += 80;
    else if (sk === 'dress' && pk === 'dress') score += 80;
    var a = titleTokens(seed);
    var b = titleTokens(p);
    var hits = 0;
    a.forEach(function (w) { if (b.indexOf(w) !== -1) hits += 1; });
    score += hits * 12;
    return score;
  }

  function sortMostSimilar(pool, seed) {
    return (pool || []).slice().sort(function (a, b) {
      return similarScore(seed, b) - similarScore(seed, a);
    });
  }

  function isShoe(p) {
    var t = textBlob(p).replace(/flatter(?:ing)?/g, ' ');
    return /\b(?:shoes?|heels?|sandals?|boots?|sneakers?|loafers?|mules?|flats?|wedges?|pumps?|slip-?ons?|footwear)\b/.test(t);
  }

  function isDress(p) {
    return /\b(?:dress(?:es)?|gowns?|jumpsuits?|rompers?|maxi|midi)\b/.test(textBlob(p));
  }

  function isClothes(p) {
    if (isShoe(p)) return false;
    return /top|blouse|skirt|pant|jean|trouser|set|outfit|coat|jacket|sweater|knit|shirt|tee|cardigan|vest|short|legging|clothes|apparel/.test(textBlob(p)) || isDress(p);
  }

  function isAvailable(p) {
    if (!p || !p.variants || !p.variants.length) return false;
    return p.variants.some(function (v) { return v.available !== false; });
  }

  function minPrice(p) {
    var min = Infinity;
    (p.variants || []).forEach(function (v) {
      if (v.available === false) return;
      var c = Number(v.price);
      if (c < min) min = c;
    });
    return min === Infinity ? 0 : min;
  }

  function normalizeCollectionProduct(raw, pool) {
    var variants = (raw.variants || []).map(function (v) {
      return {
        id: v.id,
        title: v.title,
        available: v.available !== false,
        price: parseMoneyToCents(v.price) || 0,
        compare_at_price: parseMoneyToCents(v.compare_at_price),
        option1: v.option1,
        option2: v.option2,
        option3: v.option3,
        featured_image: v.featured_image
      };
    });
    var images = (raw.images || []).map(function (img) {
      return typeof img === 'string' ? img : (img && img.src) || '';
    }).filter(Boolean);
    var featured = raw.featured_image;
    if (featured && typeof featured === 'object') featured = featured.src || '';
    if (!featured && images[0]) featured = images[0];
    var options = raw.options || [];
    if (options.length && typeof options[0] === 'object') {
      options = options.map(function (o) { return o.name || o; });
    }
    return {
      id: raw.id,
      handle: raw.handle,
      title: raw.title,
      product_type: raw.product_type || raw.type || '',
      tags: raw.tags || [],
      url: raw.url || ('/products/' + raw.handle),
      featured_image: featured,
      images: images,
      options: options,
      variants: variants,
      description: raw.description || raw.body_html || '',
      _pool: pool || ''
    };
  }

  function normalizeRecProduct(raw) {
    return normalizeCollectionProduct(raw, 'rec');
  }

  function fetchCollection(handle, pool) {
    return fetch('/collections/' + handle + '/products.json?limit=50', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        return (data.products || []).map(function (p) {
          return normalizeCollectionProduct(p, pool);
        });
      })
      .catch(function () { return []; });
  }

  function fetchComplementary(productId) {
    return fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=complementary', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { return (data && data.products) ? data.products : []; })
      .catch(function () { return []; });
  }

  function fetchRelated(productId) {
    return fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { return (data && data.products) ? data.products : []; })
      .catch(function () { return []; });
  }

  function dedupe(list) {
    var seen = {};
    return (list || []).filter(function (p) {
      if (!p || seen[String(p.id)]) return false;
      seen[String(p.id)] = true;
      return true;
    });
  }

  function getBundleProgress(itemCount) {
    var current = null;
    var next = BUNDLE_TIERS[0];
    for (var i = 0; i < BUNDLE_TIERS.length; i++) {
      if (itemCount >= BUNDLE_TIERS[i].min) current = BUNDLE_TIERS[i];
      if (itemCount < BUNDLE_TIERS[i].min) {
        next = BUNDLE_TIERS[i];
        break;
      }
      if (i === BUNDLE_TIERS.length - 1) next = null;
    }
    return { current: current, next: next };
  }

  /* ─── Complete the look (FBT) ─── */
  var SuteraaFBT = {
    root: null,
    list: null,
    totalEl: null,
    refreshBtn: null,
    preview: null,
    productId: null,
    mainPrice: 0,
    mode: 'clothes',
    shoePool: [],
    dressPool: [],
    clothesPool: [],
    products: [],
    selectedByIndex: {},
    page: 0,
    previewProduct: null,
    previewSelected: {},
    previewImgIdx: 0,
    previewRowIndex: null,

    init: function () {
      this.root = document.querySelector('[data-st-fbt]');
      if (!this.root) return;
      this.list = this.root.querySelector('[data-st-fbt-list]');
      this.totalEl = this.root.querySelector('[data-st-fbt-total]');
      this.refreshBtn = this.root.querySelector('[data-st-fbt-refresh]');
      this.preview = document.querySelector('[data-st-fbt-preview]');
      this.mainPrice = parseInt(this.root.getAttribute('data-main-price'), 10) || 0;
      this.productId = this.root.getAttribute('data-product-id');
      this.mode = this.root.getAttribute('data-mode') || 'clothes';
      this.seed = {
        id: this.productId,
        title: this.root.getAttribute('data-seed-title') || '',
        product_type: this.root.getAttribute('data-seed-type') || '',
        tags: []
      };
      if (!this.productId) return;

      var self = this;
      document.addEventListener('st:variant-updated', function (e) {
        var priceEl = document.querySelector('[data-price]');
        if (priceEl) {
          var raw = (priceEl.textContent || '').replace(/[^0-9.]/g, '');
          var dollars = parseFloat(raw);
          if (!isNaN(dollars)) self.mainPrice = Math.round(dollars * 100);
        }
        self.updateTotal();
      });

      if (this.refreshBtn) {
        this.refreshBtn.addEventListener('click', function () { self.refresh(); });
      }

      if (this.preview) {
        this.preview.querySelectorAll('[data-st-fbt-pv-close]').forEach(function (el) {
          el.addEventListener('click', function () { self.closePreview(); });
        });
        var prev = this.preview.querySelector('[data-st-fbt-pv-prev]');
        var next = this.preview.querySelector('[data-st-fbt-pv-next]');
        if (prev) prev.addEventListener('click', function () { self.shiftPreviewImage(-1); });
        if (next) next.addEventListener('click', function () { self.shiftPreviewImage(1); });
        var atc = this.preview.querySelector('[data-st-fbt-pv-atc]');
        var stack = this.preview.querySelector('[data-st-fbt-pv-stack]');
        if (atc) atc.addEventListener('click', function () { self.previewAddToCart(); });
        if (stack) stack.addEventListener('click', function () { self.previewAddToStack(); });
        window.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && self.preview.classList.contains('is-open')) self.closePreview();
        });
      }

      this.load();
    },

    pushPool: function (p) {
      if (String(p.id) === String(this.productId)) return;
      var kind = productKind(p);
      var seedKind = productKind(this.seed);
      var sameKind = kind === seedKind && kind !== 'other';
      if (!isAvailable(p) && !sameKind) return;
      if (!sameKind && minPrice(p) > ADDON_MAX_CENTS && !isShoe(p) && this.mode !== 'shoes') {
        return;
      }
      if (isShoe(p)) this.shoePool.push(p);
      else if (isJacket(p) || kind === 'jacket') this.clothesPool.push(p);
      else if (isDress(p)) this.dressPool.push(p);
      else if (isClothes(p)) this.clothesPool.push(p);
      else if (sameKind || minPrice(p) <= ADDON_MAX_CENTS) this.clothesPool.push(p);
    },

    load: function () {
      var self = this;
      Promise.all([
        fetchCollection('shoes', 'shoes'),
        fetchCollection('party-dresses', 'dresses'),
        fetchCollection('summer-outfits', 'dresses'),
        fetchCollection('clothes', 'clothes'),
        fetchCollection('all', 'catalog'),
        fetchComplementary(this.productId),
        fetchRelated(this.productId)
      ]).then(function (results) {
        self.shoePool = [];
        self.dressPool = [];
        self.clothesPool = [];

        (results[0] || []).forEach(function (p) { self.pushPool(p); });
        (results[1] || []).forEach(function (p) { self.pushPool(p); });
        (results[2] || []).forEach(function (p) { self.pushPool(p); });
        (results[3] || []).forEach(function (p) { self.pushPool(p); });
        (results[4] || []).forEach(function (p) { self.pushPool(p); });
        ;[results[5], results[6]].forEach(function (arr) {
          (arr || []).forEach(function (raw) {
            self.pushPool(normalizeRecProduct(raw));
          });
        });

        self.shoePool = sortMostSimilar(dedupe(self.shoePool), self.seed);
        self.dressPool = sortMostSimilar(dedupe(self.dressPool), self.seed);
        self.clothesPool = sortMostSimilar(dedupe(self.clothesPool), self.seed);

        var sub = self.root.querySelector('[data-st-fbt-sub]');
        if (sub) {
          var kind = productKind(self.seed);
          if (kind === 'dress') sub.textContent = 'More dresses like this. Unchecked by default. Bundle savings apply automatically at checkout.';
          else if (kind === 'jacket') sub.textContent = 'More jackets like this. Unchecked by default. Bundle savings apply automatically at checkout.';
          else if (kind === 'shoes') sub.textContent = 'More shoes like this. Unchecked by default. Bundle savings apply automatically at checkout.';
          else sub.textContent = 'More pieces like this. Unchecked by default. Bundle savings apply automatically at checkout.';
        }

        if (!self.shoePool.length && !self.dressPool.length && !self.clothesPool.length) {
          self.root.hidden = true;
          return;
        }
        self.page = 0;
        self.applyPage();
        if (!self.products.length) {
          self.root.hidden = true;
          return;
        }
        self.root.hidden = false;
      });
    },

    pickSet: function () {
      var picked = [];
      var used = {};
      var self = this;
      var seedKind = productKind(this.seed);

      function take(pool, n, role, sameKindOnly) {
        if (!pool.length || picked.length >= n) return;
        var start = pool.length ? (self.page * 3) % pool.length : 0;
        for (var i = 0; i < pool.length && picked.length < n; i++) {
          var p = pool[(start + i) % pool.length];
          if (used[String(p.id)]) continue;
          if (sameKindOnly && productKind(p) !== seedKind) continue;
          used[String(p.id)] = true;
          p._role = role;
          picked.push(p);
        }
      }

      if (seedKind === 'shoes') {
        take(this.shoePool, 3, 'shoe', true);
      } else if (seedKind === 'dress') {
        take(this.dressPool, 3, 'dress', true);
      } else if (seedKind === 'jacket') {
        take(this.clothesPool, 3, 'jacket', true);
      } else {
        take(this.clothesPool, 3, 'clothes', true);
        if (picked.length < 3) take(this.dressPool, 3, 'dress', true);
      }

      return picked.slice(0, 3);
    },

    applyPage: function () {
      this.products = this.pickSet();
      this.selectedByIndex = {};
      var self = this;
      this.products.forEach(function (p, i) {
        var v = null;
        for (var n = 0; n < p.variants.length; n++) {
          if (p.variants[n].available !== false) { v = p.variants[n]; break; }
        }
        self.selectedByIndex[i] = v || p.variants[0];
      });
      this.render();
    },

    refresh: function () {
      var self = this;
      if (this.refreshBtn) {
        this.refreshBtn.classList.add('is-spinning');
        setTimeout(function () { self.refreshBtn.classList.remove('is-spinning'); }, 550);
      }
      this.page += 1;
      this.applyPage();
    },

    imageUrl: function (product, variant) {
      var url = '';
      if (variant && variant.featured_image) {
        url = typeof variant.featured_image === 'string'
          ? variant.featured_image
          : (variant.featured_image.src || '');
      }
      if (!url && product.featured_image) url = product.featured_image;
      if (!url && product.images && product.images[0]) url = product.images[0];
      return getSizedImage(url, '160x') || url;
    },

    optionValues: function (product, pos) {
      var values = [];
      (product.variants || []).forEach(function (v) {
        var val = v['option' + pos];
        if (val && values.indexOf(val) === -1) values.push(val);
      });
      return values;
    },

    findVariantForOptions: function (product, selected) {
      return (product.variants || []).find(function (v) {
        for (var i = 1; i <= (product.options || []).length; i++) {
          if (selected[i] && v['option' + i] !== selected[i]) return false;
        }
        return true;
      }) || null;
    },

    priceHtml: function (variant) {
      if (!variant) return '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        return '<s>' + money(variant.compare_at_price) + '</s>' + money(variant.price);
      }
      return money(variant.price);
    },

    sizeButtonsHtml: function (product, index, current) {
      var options = product.options || [];
      var sizePos = 1;
      for (var i = 0; i < options.length; i++) {
        if (/size|eu|us|width/i.test(String(options[i]))) {
          sizePos = i + 1;
          break;
        }
      }
      var values = this.optionValues(product, sizePos);
      if (values.length <= 1 || values.length > 8 || options.length > 1) {
        return '<button type="button" class="st-fbt__more" data-st-fbt-preview-btn data-index="' + index + '">Select size / preview</button>';
      }
      var html = '<div class="st-fbt__sizes" data-st-fbt-sizes data-index="' + index + '" data-pos="' + sizePos + '">';
      values.forEach(function (val) {
        var match = (product.variants || []).find(function (v) {
          return v['option' + sizePos] === val && v.available !== false;
        });
        var any = (product.variants || []).find(function (v) { return v['option' + sizePos] === val; });
        var target = match || any;
        if (!target) return;
        var pressed = current && current['option' + sizePos] === val;
        html += '<button type="button" class="st-fbt__size' + (!match ? ' is-unavailable' : '') + '" data-value="' +
          esc(val) + '" data-variant-id="' + target.id + '" data-price="' + target.price + '" aria-pressed="' +
          (pressed ? 'true' : 'false') + '"' + (!match ? ' disabled' : '') + '>' + esc(val) + '</button>';
      });
      html += '</div>';
      return html;
    },

    badgeFor: function (product) {
      var kind = product._role || productKind(product);
      if (kind === 'shoe' || kind === 'shoes') return 'Shoes';
      if (kind === 'dress') return 'Dress';
      if (kind === 'jacket') return 'Jacket';
      return 'Similar';
    },

    render: function () {
      var self = this;
      if (!this.list) return;
      if (!this.products.length) {
        this.list.innerHTML = '<p class="st-fbt__loading">No pairings right now. Try Refresh.</p>';
        return;
      }
      var html = '';
      this.products.forEach(function (product, index) {
        var current = self.selectedByIndex[index] || product.variants[0];
        var img = self.imageUrl(product, current);
        var isFeature = false;
        html +=
          '<div class="st-fbt__row' + (isFeature ? ' is-feature' : '') + '">' +
            '<input type="checkbox" class="st-fbt__check" data-st-fbt-check data-index="' + index + '" data-variant-id="' + current.id + '" data-price="' + current.price + '"' + (current.available === false ? ' disabled' : '') + '>' +
            '<button type="button" class="st-fbt__thumb-wrap" data-st-fbt-preview-btn data-index="' + index + '" aria-label="Preview ' + esc(product.title) + '">' +
              '<img class="st-fbt__thumb" data-st-fbt-thumb data-index="' + index + '" src="' + esc(img) + '" alt="" width="64" height="85" loading="lazy">' +
              '<span class="st-fbt__preview-cue">Preview</span>' +
            '</button>' +
            '<div class="st-fbt__meta">' +
              '<span class="st-fbt__badge">' + esc(self.badgeFor(product)) + '</span>' +
              '<div class="st-fbt__top">' +
                '<button type="button" class="st-fbt__name" data-st-fbt-preview-btn data-index="' + index + '">' + esc(product.title) + '</button>' +
                '<span class="st-fbt__price" data-st-fbt-price data-index="' + index + '">' + self.priceHtml(current) + '</span>' +
              '</div>' +
              self.sizeButtonsHtml(product, index, current) +
            '</div>' +
          '</div>';
      });
      this.list.innerHTML = html;
      this.bindRowEvents();
      this.updateTotal();
    },

    bindRowEvents: function () {
      var self = this;
      this.list.querySelectorAll('[data-st-fbt-check]').forEach(function (cb) {
        cb.addEventListener('change', function () { self.updateTotal(); });
      });
      this.list.querySelectorAll('[data-st-fbt-preview-btn]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          self.openPreview(parseInt(btn.getAttribute('data-index'), 10));
        });
      });
      this.list.querySelectorAll('.st-fbt__size').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var wrap = btn.closest('[data-st-fbt-sizes]');
          var idx = parseInt(wrap.getAttribute('data-index'), 10);
          var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
          var price = parseInt(btn.getAttribute('data-price'), 10);
          wrap.querySelectorAll('.st-fbt__size').forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          var match = (self.products[idx].variants || []).find(function (v) {
            return String(v.id) === String(vid);
          });
          if (match) self.selectedByIndex[idx] = match;
          var check = self.list.querySelector('[data-st-fbt-check][data-index="' + idx + '"]');
          if (check) {
            check.setAttribute('data-variant-id', String(vid));
            check.setAttribute('data-price', String(price));
          }
          var priceEl = self.list.querySelector('[data-st-fbt-price][data-index="' + idx + '"]');
          if (priceEl && match) priceEl.innerHTML = self.priceHtml(match);
          var thumb = self.list.querySelector('[data-st-fbt-thumb][data-index="' + idx + '"]');
          if (thumb && match) thumb.src = self.imageUrl(self.products[idx], match);
          self.updateTotal();
        });
      });
    },

    openPreview: function (index) {
      if (!this.preview || !this.products[index]) return;
      this.previewRowIndex = index;
      this.previewProduct = this.products[index];
      this.previewImgIdx = 0;
      this.previewSelected = {};
      var current = this.selectedByIndex[index];
      var opts = this.previewProduct.options || [];
      for (var i = 1; i <= opts.length; i++) {
        this.previewSelected[i] = current ? current['option' + i] : null;
      }
      this.preview.querySelector('[data-st-fbt-pv-title]').textContent = this.previewProduct.title;
      var desc = this.preview.querySelector('[data-st-fbt-pv-desc]');
      var rawDesc = (this.previewProduct.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
      desc.textContent = rawDesc ? rawDesc.slice(0, 220) : 'See full details on the product page.';
      this.renderPreviewThumbs();
      this.renderPreviewOptions();
      this.syncPreviewVariant();
      this.preview.classList.add('is-open');
      this.preview.setAttribute('aria-hidden', 'false');
      document.body.classList.add('st-fbt-preview-open');
      document.body.style.overflow = 'hidden';
      var scroll = this.preview.querySelector('.st-fbt-pv__scroll');
      if (scroll) scroll.scrollTop = 0;
    },

    renderPreviewThumbs: function () {
      var self = this;
      var product = this.previewProduct;
      var thumbs = this.preview.querySelector('[data-st-fbt-pv-thumbs]');
      var images = product.images && product.images.length ? product.images : [product.featured_image].filter(Boolean);
      product._previewImages = images;
      thumbs.innerHTML = images.map(function (src, i) {
        return '<button type="button" class="st-fbt-pv__thumb' + (i === self.previewImgIdx ? ' is-active' : '') + '" data-img-idx="' + i + '">' +
          '<img src="' + esc(getSizedImage(src, '120x') || src) + '" alt="" loading="lazy">' +
          '</button>';
      }).join('');
      thumbs.querySelectorAll('[data-img-idx]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.previewImgIdx = parseInt(btn.getAttribute('data-img-idx'), 10);
          self.updatePreviewImage();
        });
      });
      this.updatePreviewImage();
    },

    updatePreviewImage: function () {
      var images = (this.previewProduct && this.previewProduct._previewImages) || [];
      if (!images.length) return;
      if (this.previewImgIdx < 0) this.previewImgIdx = images.length - 1;
      if (this.previewImgIdx >= images.length) this.previewImgIdx = 0;
      var src = images[this.previewImgIdx];
      var img = this.preview.querySelector('[data-st-fbt-pv-img]');
      img.src = src + (src.indexOf('?') === -1 ? '?width=1200' : '&width=1200');
      img.alt = this.previewProduct.title;
      this.preview.querySelector('[data-st-fbt-pv-counter]').textContent =
        (this.previewImgIdx + 1) + ' / ' + images.length;
      var self = this;
      this.preview.querySelectorAll('.st-fbt-pv__thumb').forEach(function (t, i) {
        t.classList.toggle('is-active', i === self.previewImgIdx);
      });
    },

    shiftPreviewImage: function (delta) {
      this.previewImgIdx += delta;
      this.updatePreviewImage();
    },

    renderPreviewOptions: function () {
      var self = this;
      var product = this.previewProduct;
      var wrap = this.preview.querySelector('[data-st-fbt-pv-options]');
      if (!product.options || !product.options.length ||
          (product.variants.length === 1 && product.variants[0].title === 'Default Title')) {
        wrap.innerHTML = '';
        return;
      }
      var html = '';
      product.options.forEach(function (optName, idx) {
        var pos = idx + 1;
        var values = self.optionValues(product, pos);
        html += '<div class="st-fbt-pv__group" data-st-fbt-pv-group data-pos="' + pos + '">' +
          '<p class="st-fbt-pv__opt-label">' + esc(String(optName)) +
          ': <strong data-st-fbt-pv-selected>' + esc(self.previewSelected[pos] || '') + '</strong></p>' +
          '<div class="st-fbt-pv__values">';
        values.forEach(function (val) {
          var available = (product.variants || []).some(function (v) {
            return v['option' + pos] === val && v.available !== false;
          });
          var pressed = self.previewSelected[pos] === val;
          html += '<button type="button" class="st-fbt-pv__val' + (!available ? ' is-unavailable' : '') +
            '" data-pos="' + pos + '" data-value="' + esc(val) + '" aria-pressed="' +
            (pressed ? 'true' : 'false') + '"' + (!available ? ' disabled' : '') + '>' +
            esc(val) + '</button>';
        });
        html += '</div></div>';
      });
      wrap.innerHTML = html;
      wrap.querySelectorAll('.st-fbt-pv__val').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var pos = btn.getAttribute('data-pos');
          self.previewSelected[pos] = btn.getAttribute('data-value');
          var group = btn.closest('[data-st-fbt-pv-group]');
          group.querySelectorAll('.st-fbt-pv__val').forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          var label = group.querySelector('[data-st-fbt-pv-selected]');
          if (label) label.textContent = btn.getAttribute('data-value');
          self.syncPreviewVariant();
        });
      });
    },

    syncPreviewVariant: function () {
      var v = this.findVariantForOptions(this.previewProduct, this.previewSelected);
      var priceEl = this.preview.querySelector('[data-st-fbt-pv-price]');
      var atc = this.preview.querySelector('[data-st-fbt-pv-atc]');
      if (!v) {
        atc.disabled = true;
        atc.textContent = 'Unavailable';
        return;
      }
      priceEl.innerHTML = this.priceHtml(v);
      atc.disabled = !v.available;
      atc.textContent = v.available ? 'Add to Cart' : 'Sold Out';
    },

    previewCurrentVariant: function () {
      return this.findVariantForOptions(this.previewProduct, this.previewSelected);
    },

    previewAddToCart: function () {
      var v = this.previewCurrentVariant();
      if (!v || !v.available) return;
      var self = this;
      var atc = this.preview.querySelector('[data-st-fbt-pv-atc]');
      atc.disabled = true;
      atc.textContent = 'Adding…';
      if (window.stCartDrawer && typeof window.stCartDrawer.addItems === 'function') {
        window.stCartDrawer.addItems([{ id: v.id, quantity: 1 }], false, { skipComplete: false }).then(function () {
          self.closePreview();
          atc.disabled = false;
          atc.textContent = 'Add to Cart';
        });
      } else {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: v.id, quantity: 1 })
        }).then(function () {
          self.closePreview();
          if (window.stCartDrawer) window.stCartDrawer.open();
          atc.disabled = false;
          atc.textContent = 'Add to Cart';
        });
      }
    },

    previewAddToStack: function () {
      var v = this.previewCurrentVariant();
      if (!v || this.previewRowIndex == null) return;
      var idx = this.previewRowIndex;
      var rowProduct = this.products[idx];
      var match = rowProduct && (rowProduct.variants || []).find(function (rv) {
        return String(rv.id) === String(v.id);
      });
      this.selectedByIndex[idx] = match || v;
      this.render();
      var check = this.list.querySelector('[data-st-fbt-check][data-index="' + idx + '"]');
      if (check) {
        check.checked = true;
        check.setAttribute('data-variant-id', String(v.id));
        check.setAttribute('data-price', String(v.price));
      }
      this.updateTotal();
      this.closePreview();
    },

    closePreview: function () {
      if (!this.preview) return;
      this.preview.classList.remove('is-open');
      this.preview.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('st-fbt-preview-open');
      var drawer = document.getElementById('st-cd');
      if (!drawer || !drawer.classList.contains('is-open')) {
        document.body.style.overflow = '';
      }
    },

    getSelectedItems: function () {
      if (!this.list) return [];
      var items = [];
      this.list.querySelectorAll('[data-st-fbt-check]:checked').forEach(function (cb) {
        var id = parseInt(cb.getAttribute('data-variant-id'), 10);
        if (id) items.push({ id: id, quantity: 1 });
      });
      return items;
    },

    clearSelected: function () {
      if (!this.list) return;
      this.list.querySelectorAll('[data-st-fbt-check]:checked').forEach(function (cb) {
        cb.checked = false;
      });
      this.updateTotal();
    },

    updateTotal: function () {
      if (!this.totalEl || !this.list) return;
      var extras = 0;
      var count = 0;
      this.list.querySelectorAll('[data-st-fbt-check]:checked').forEach(function (cb) {
        extras += parseInt(cb.getAttribute('data-price'), 10) || 0;
        count += 1;
      });
      if (count === 0) {
        this.totalEl.hidden = true;
        return;
      }
      var total = this.mainPrice + extras;
      this.totalEl.hidden = false;
      this.totalEl.innerHTML = 'Look total: <span>' + money(total) + '</span> · ' + (count + 1) + ' items. Bundle savings at checkout';
    }
  };

  /* ─── Complete your order (post-ATC) ─── */
  var SuteraaCompleteOrder = {
    root: null,
    list: null,
    tierEl: null,
    addBtn: null,
    pool: [],
    selected: {},
    pendingCart: null,
    skipOpen: false,

    init: function () {
      this.root = document.querySelector('[data-st-complete]');
      if (!this.root) return;
      this.list = this.root.querySelector('[data-st-complete-list]');
      this.tierEl = this.root.querySelector('[data-st-complete-tier]');
      this.addBtn = this.root.querySelector('[data-st-complete-add]');
      var self = this;
      this.root.querySelectorAll('[data-st-complete-skip]').forEach(function (el) {
        el.addEventListener('click', function () { self.finish(false); });
      });
      if (this.addBtn) {
        this.addBtn.addEventListener('click', function () { self.finish(true); });
      }
    },

    firstAvailableVariant: function (p) {
      if (!p.variants) return null;
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].available !== false) return p.variants[i];
      }
      return p.variants[0] || null;
    },

    offer: function (cart, opts) {
      var self = this;
      opts = opts || {};
      this.pendingCart = cart;
      this.skipOpen = !!opts.skipOpen;
      this.selected = {};
      if (!this.root || !this.list) {
        if (!this.skipOpen && window.stCartDrawer) window.stCartDrawer.open();
        return Promise.resolve(cart);
      }

      var fbtExtras = (window.SuteraaFBT && typeof window.SuteraaFBT.getSelectedItems === 'function')
        ? window.SuteraaFBT.getSelectedItems()
        : [];
      if (fbtExtras.length > 0) {
        if (typeof window.SuteraaFBT.clearSelected === 'function') window.SuteraaFBT.clearSelected();
        if (!this.skipOpen && window.stCartDrawer) window.stCartDrawer.open();
        return Promise.resolve(cart);
      }

      var state = getBundleProgress(cart.item_count || 0);
      if (this.tierEl) {
        if (state.next) {
          var need = state.next.min - (cart.item_count || 0);
          this.tierEl.hidden = false;
          this.tierEl.innerHTML = 'Add <span>' + need + ' more</span> to unlock <span>' + state.next.pct + '% off</span> at checkout.';
        } else {
          this.tierEl.hidden = true;
        }
      }

      this.list.innerHTML = '<p class="st-complete__loading">Finding pieces that pair well…</p>';

      var inCart = {};
      (cart.items || []).forEach(function (it) {
        if (it.product_id) inCart[String(it.product_id)] = true;
        if (it.handle) inCart[it.handle] = true;
      });

      var seedItem = (cart.items && cart.items.length) ? cart.items[cart.items.length - 1] : null;
      var seedId = (seedItem && seedItem.product_id) || null;
      var seed = {
        id: seedId,
        title: (seedItem && (seedItem.product_title || seedItem.title)) || '',
        product_type: (seedItem && seedItem.product_type) || '',
        handle: (seedItem && seedItem.handle) || '',
        tags: []
      };

      return Promise.all([
        fetchCollection('party-dresses', 'dresses'),
        fetchCollection('summer-outfits', 'dresses'),
        fetchCollection('clothes', 'clothes'),
        fetchCollection('all', 'catalog'),
        fetchCollection('shoes', 'shoes'),
        seedId ? fetchRelated(seedId) : Promise.resolve([]),
        seedId ? fetchComplementary(seedId) : Promise.resolve([])
      ]).then(function (results) {
        var pool = [];
        var seedKind = productKind(seed);
        function consider(p) {
          if (inCart[String(p.id)] || inCart[p.handle]) return;
          if (!(isShoe(p) || isClothes(p) || isDress(p) || isJacket(p))) return;
          var kind = productKind(p);
          var sameKind = kind === seedKind && seedKind !== 'other';
          if (seedKind !== 'other' && !sameKind) return;
          if (!sameKind && minPrice(p) > ADDON_MAX_CENTS) return;
          var v = self.firstAvailableVariant(p);
          if (!v) return;
          pool.push({ product: p, variant: v, score: similarScore(seed, p) });
        }
        (results[0] || []).forEach(function (p) { consider(p); });
        (results[1] || []).forEach(function (p) { consider(p); });
        (results[2] || []).forEach(function (p) { consider(p); });
        (results[3] || []).forEach(function (p) { consider(p); });
        (results[4] || []).forEach(function (p) { consider(p); });
        ;[results[5], results[6]].forEach(function (arr) {
          (arr || []).forEach(function (raw) { consider(normalizeRecProduct(raw)); });
        });
        self.pool = pool
          .filter(function (r) { return r && r.product && r.variant; })
          .reduce(function (acc, row) {
            if (acc._seen[String(row.product.id)]) return acc;
            acc._seen[String(row.product.id)] = true;
            acc.list.push(row);
            return acc;
          }, { _seen: {}, list: [] }).list;

        self.pool.sort(function (a, b) { return (b.score || 0) - (a.score || 0); });

        self.pool = self.pool.slice(0, 3);
        if (!self.pool.length) {
          if (!self.skipOpen && window.stCartDrawer) window.stCartDrawer.open();
          return cart;
        }
        self.renderList();
        self.open();
        return cart;
      });
    },

    renderList: function () {
      var self = this;
      if (!this.pool.length) {
        this.list.innerHTML = '<p class="st-complete__loading">No extras available right now. Continue to bag.</p>';
        if (this.addBtn) this.addBtn.disabled = true;
        return;
      }
      this.list.innerHTML = this.pool.map(function (row, idx) {
        var p = row.product;
        var v = row.variant;
        var img = (p.images && p.images[0]) || p.featured_image || '';
        if (img && typeof img === 'object') img = img.src || '';
        return (
          '<label class="st-complete__item" data-st-complete-item data-idx="' + idx + '">' +
            '<input type="checkbox" class="st-complete__check" data-st-complete-check data-idx="' + idx + '">' +
            '<img src="' + esc(String(img)) + '" alt="" width="64" height="85" loading="lazy">' +
            '<span>' +
              '<p class="st-complete__name">' + esc(p.title) + '</p>' +
              '<p class="st-complete__price">' + money(v.price) + '</p>' +
              '<span class="st-complete__badge">Optional</span>' +
            '</span>' +
          '</label>'
        );
      }).join('');

      this.list.querySelectorAll('[data-st-complete-check]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          var idx = parseInt(cb.getAttribute('data-idx'), 10);
          var item = cb.closest('[data-st-complete-item]');
          if (cb.checked) self.selected[idx] = true;
          else delete self.selected[idx];
          if (item) item.classList.toggle('is-on', cb.checked);
          var count = Object.keys(self.selected).length;
          if (self.addBtn) {
            self.addBtn.disabled = count === 0;
            self.addBtn.textContent = count === 0
              ? 'Add selected extras'
              : (count === 1 ? 'Add 1 extra & continue' : 'Add ' + count + ' extras & continue');
          }
        });
      });
      if (this.addBtn) {
        this.addBtn.disabled = true;
        this.addBtn.textContent = 'Add selected extras';
      }
    },

    open: function () {
      if (!this.root) return;
      this.root.classList.add('is-open');
      this.root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('st-complete-open');
    },

    close: function () {
      if (!this.root) return;
      this.root.classList.remove('is-open');
      this.root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('st-complete-open');
    },

    finish: function (withSelected) {
      var self = this;
      var items = [];
      if (withSelected) {
        Object.keys(this.selected).forEach(function (k) {
          var row = self.pool[parseInt(k, 10)];
          if (row && row.variant) items.push({ id: row.variant.id, quantity: 1 });
        });
      }
      this.close();
      if (items.length && window.stCartDrawer && typeof window.stCartDrawer.addItems === 'function') {
        window.stCartDrawer.addItems(items, self.skipOpen, { skipComplete: true }).then(function () {
          if (!self.skipOpen) window.stCartDrawer.open();
        });
      } else if (!this.skipOpen && window.stCartDrawer) {
        window.stCartDrawer.open();
      }
    }
  };

  var SuteraaRecent = {
    KEY: 'st_recent_handles_v1',
    MAX: 12,
    cache: {},

    read: function () {
      try {
        var raw = localStorage.getItem(this.KEY);
        var list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list.filter(Boolean) : [];
      } catch (e) {
        return [];
      }
    },

    write: function (list) {
      try {
        localStorage.setItem(this.KEY, JSON.stringify(list.slice(0, this.MAX)));
      } catch (e) {}
    },

    track: function (handle) {
      if (!handle) return;
      var list = this.read().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      this.write(list);
    },

    trackFromPage: function () {
      var el = document.querySelector('[data-st-recent-track-handle]');
      if (el) this.track(el.getAttribute('data-st-recent-track-handle'));
      else if (window.meta && meta.product && meta.product.handle) this.track(meta.product.handle);
    },

    fetchProduct: function (handle) {
      var self = this;
      if (this.cache[handle]) return Promise.resolve(this.cache[handle]);
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p) self.cache[handle] = p;
          return p;
        })
        .catch(function () { return null; });
    },

    cardHtml: function (p) {
      if (!p) return '';
      var img = p.featured_image || (p.images && p.images[0]) || '';
      if (img && typeof img === 'object') img = img.src || '';
      var price = p.price_min != null ? p.price_min : p.price;
      var compare = p.compare_at_price_min || p.compare_at_price || 0;
      var onSale = compare > price;
      var priceHtml = onSale
        ? '<s>' + money(compare) + '</s><span class="is-sale">' + money(price) + '</span>'
        : '<span>' + money(price) + '</span>';
      var imgSrc = String(img);
      if (imgSrc && imgSrc.indexOf('cdn.shopify.com') !== -1 && imgSrc.indexOf('_600x') === -1) {
        imgSrc = imgSrc.replace(/(\.[a-zA-Z]+)(\?|$)/, '_600x$1$2');
      }
      return (
        '<article class="st-recent__card">' +
          '<a class="st-recent__link" href="/products/' + esc(p.handle) + '">' +
            '<div class="st-recent__img">' +
              (imgSrc ? '<img src="' + esc(imgSrc) + '" alt="" width="400" height="533" loading="lazy">' : '') +
            '</div>' +
            '<h3 class="st-recent__name">' + esc(p.title) + '</h3>' +
            '<p class="st-recent__price">' + priceHtml + '</p>' +
          '</a>' +
        '</article>'
      );
    },

    render: function () {
      var section = document.querySelector('[data-st-recent]');
      var track = document.querySelector('[data-st-recent-track]');
      if (!section || !track) return;
      var current = document.querySelector('[data-st-recent-track-handle]');
      var currentHandle = current ? current.getAttribute('data-st-recent-track-handle') : '';
      var handles = this.read().filter(function (h) { return h && h !== currentHandle; }).slice(0, 8);
      if (!handles.length) {
        section.hidden = true;
        return;
      }
      var self = this;
      Promise.all(handles.map(function (h) { return self.fetchProduct(h); })).then(function (products) {
        var html = products.map(function (p) { return self.cardHtml(p); }).filter(Boolean).join('');
        if (!html) {
          section.hidden = true;
          return;
        }
        track.innerHTML = html;
        section.hidden = false;
      });
    }
  };

  function boot() {
    SuteraaFBT.init();
    SuteraaCompleteOrder.init();
    SuteraaRecent.trackFromPage();
    SuteraaRecent.render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.SuteraaFBT = SuteraaFBT;
  window.SuteraaCompleteOrder = SuteraaCompleteOrder;
  window.SuteraaRecent = SuteraaRecent;
})();
